import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import Conections from "../../components/Conections";

const ACTIVE_STATUSES = ["open", "pending", "bot"];

const storeDraft = (ticketId, text) => {
  if (!ticketId || !text) return;
  try {
    sessionStorage.setItem(`pendingDraft-${ticketId}`, text);
  } catch (err) {}
};

const getErrorMessage = (err) =>
  err?.response?.data?.error ||
  err?.response?.data?.message ||
  "No se pudo abrir el chat.";

const OpenChat = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useContext(AuthContext);

  const [number, setNumber] = useState(searchParams.get("phone") || "");
  const [text, setText] = useState(searchParams.get("text") || "");
  const [conection, setConection] = useState("");
  const [selectedQueue, setSelectedQueue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (selectedQueue === "" && user.queues?.length === 1) {
      setSelectedQueue(user.queues[0].id);
    }
  }, [user.queues, selectedQueue]);

  const goToTicket = (ticket) => {
    storeDraft(ticket.id, text.trim());
    navigate(`/tickets/${ticket.uuid}`, { replace: true });
  };

  const handleClose = () => {
    navigate("/tickets", { replace: true });
  };

  const handleOpenChat = async () => {
    setError("");
    if (!number.trim()) {
      setError("Escriba un número.");
      return;
    }
    if (selectedQueue === "" && user.profile !== "admin") {
      setError("Seleccione un departamento.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/contacts/resolve", {
        number,
        whatsappId: conection || undefined,
      });

      if (data.ticket && ACTIVE_STATUSES.includes(data.ticket.status)) {
        goToTicket(data.ticket);
        return;
      }

      const { data: ticket } = await api.post("/tickets", {
        contactId: data.contact.id,
        queueId: selectedQueue !== "" ? selectedQueue : null,
        whatsappId: conection || null,
        userId: user.id,
        status: "open",
      });
      goToTicket(ticket);
    } catch (err) {
      setError(getErrorMessage(err));
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={handleClose}>
      <DialogTitle>Abrir chat</DialogTitle>
      <DialogContent dividers>
        <Grid style={{ width: 300 }} container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              autoFocus
              label="Número"
              variant="outlined"
              value={number}
              onChange={(e) => {
                setNumber(e.target.value);
                setError("");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !loading) handleOpenChat();
              }}
            />
          </Grid>
          <Grid size={12}>
            <Conections
              value={conection}
              onChange={(value) => {
                setConection(value);
                setError("");
              }}
            />
          </Grid>
          <Grid size={12}>
            <Select
              fullWidth
              displayEmpty
              variant="outlined"
              value={selectedQueue}
              onChange={(e) => setSelectedQueue(e.target.value)}
              renderValue={() => {
                if (selectedQueue === "") return "Seleccione un departamento: ";
                const queue = user.queues.find((q) => q.id === selectedQueue);
                return queue?.name;
              }}
            >
              {user.queues?.map((queue) => (
                <MenuItem dense key={queue.id} value={queue.id}>
                  <ListItemText primary={queue.name} />
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              label="Mensaje (opcional)"
              variant="outlined"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </Grid>
          {error && (
            <Grid size={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          disabled={loading}
          variant="outlined"
        >
          Cancelar
        </Button>
        <ButtonWithSpinner
          variant="contained"
          type="button"
          onClick={handleOpenChat}
          color="primary"
          loading={loading}
        >
          Abrir chat
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default OpenChat;
